import type { ReactNode } from 'react';
import {
  visuallyHidden,
  visuallyHiddenBelowSm,
  visuallyHiddenBelowXl,
} from '../../foundations/interaction.css';

export interface VisuallyHiddenProps {
  children: ReactNode;
  /** Hide only below this breakpoint and stay visible on wider screens. */
  below?: 'sm' | 'xl';
}

const BELOW = { sm: visuallyHiddenBelowSm, xl: visuallyHiddenBelowXl } as const;

/** Text for screen readers only (e.g. "opens in a new tab" next to an icon). */
export function VisuallyHidden({ children, below }: VisuallyHiddenProps) {
  return <span className={below ? BELOW[below] : visuallyHidden}>{children}</span>;
}
